// @see TS version: assets/scripts/enums/officeType.ts
export default {
  OPEN_SPACE: 'open_space',
  PRIVATE: 'private',
  INDEPENDENT: 'independent',
};
